import { html } from 'lit';
import { createElement, Mic } from 'lucide';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-mic')
export class PdsIconMic extends PdsIcon {
  createIconElement(): SVGElement {
    return createElement(Mic);
  }

  render() {
    return html`${this.icon}`;
  }
}
